import { render, staticRenderFns } from "./user-task-list-component.vue?vue&type=template&id=0253f462&scoped=true"
import script from "./user-task-list-component.ts?vue&type=script&lang=ts&external"
export * from "./user-task-list-component.ts?vue&type=script&lang=ts&external"
import style0 from "./user-task-list-component.scss?vue&type=style&index=0&id=0253f462&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0253f462",
  null
  
)

export default component.exports